/**
 * Stub for @solana/web3.js
 * 
 * This is an optional peer dependency of @coinflowlabs/react that we don't need
 * for our payment processing use case. This stub prevents Vite from failing
 * when it tries to resolve the dependency.
 * 
 * If you need actual Solana functionality, install @solana/web3.js:
 *   npm install @solana/web3.js
 */

// Export minimal stubs that Coinflow might reference
export const Connection = class {};
export const PublicKey = class {};
export const Keypair = class {};
export const Transaction = class {};
export const SystemProgram = {};
export const LAMPORTS_PER_SOL = 1_000_000_000;

// Export a default empty object to satisfy any default imports
export default {};

